import { Injectable, signal, computed } from '@angular/core';
import { IEstablecimiento, TipoDispositivo } from 'modelos/src';
import { Observable, Subject } from 'rxjs';
import { LoginService } from '../login/login.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  public establecimiento$ = new Subject<IEstablecimiento>();
  private establecimiento?: IEstablecimiento;
  public modoOscuro$ = new Subject<boolean>();
  private _collapsed = signal(true);
  public sideNavWidth = computed(() => (this._collapsed() ? '85px' : '300px'));

  get tiposDispositivos() {
    return LoginService.getTiposDispositivo();
  }

  constructor() { }

  public reset(): void {
    this.establecimiento$ = new Subject<IEstablecimiento>();
    this.establecimiento = undefined;
  }

  public subscribeEstablecimiento(): Observable<IEstablecimiento> {
    return this.establecimiento$.asObservable();
  }

  public setEstablecimiento(establecimiento?: IEstablecimiento) {
    this.establecimiento = establecimiento;
    this.establecimiento$.next(establecimiento!);
  }

  public getEstablecimiento(): IEstablecimiento | undefined {
    return this.establecimiento;
  }

  // Permisos de Dispositivo
  public puedeVer(tipo: TipoDispositivo) {
    const user = LoginService.getUsuario();
    for (const p of user.permisos) {
      const puede = p.tiposDispositivo?.find((t) => t === tipo);
      if (puede) {
        return true;
      }
    }
    return false;
  }

  public toggleCollapsed() {
    this._collapsed.set(!this._collapsed());
  }

  public get collapsed() {
    return this._collapsed();
  }
}
